// extracted by mini-css-extract-plugin
export var displayNone = "_ua-6";
export var imgContainer = "_ua-2";
export var overflowHidden = "_ua-3";
export var productInfoCardButtonContainer = "_ua-5";
export var productTitleText = "_ua-4";
export var rightArrow = "_ua-1";
export var rightArrowContainer = "_ua-0";